"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const url_regex_1 = __importDefault(require("url-regex"));
__export(require("./mixins"));
__export(require("./color"));
var wrap_default_theme_1 = require("./wrap-default-theme");
exports.wrapDefaultTheme = wrap_default_theme_1.default;
exports.isModifiedEvent = (event) => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
exports.isOutsideLink = (url) => url_regex_1.default({ exact: true }).test(url);
/**
 * Detect if a key event originated from a cmd+enter
 */
exports.isCmdEnter = (ev) => {
    const crossBrowserSafeKeycode = ev.which || ev.keyCode;
    const modifierKey = ev.ctrlKey || ev.metaKey;
    return crossBrowserSafeKeycode === exports.keyCodes.enter && modifierKey;
};
/**
 * Return the initials in 2 letters from a full name.
 *
 * @param name
 */
exports.getInitials = (name) => {
    if (!name) {
        return "";
    }
    const fullInitials = name
        .split(" ")
        .map(([firstLetter]) => firstLetter.toUpperCase())
        .join("");
    const [firstInitial, , lastInitial] = fullInitials;
    return fullInitials.length > 2 ? firstInitial + lastInitial : fullInitials;
};
exports.keyCodes = {
    /** 38 */
    up: 38,
    /** 40 */
    down: 40,
    /** 13 */
    enter: 13,
    /** 27 */
    esc: 27,
};
//# sourceMappingURL=index.js.map